import React from "react";

const AngleBracketIcon = () => {
  return (
    <div>
      <svg
        width="9"
        height="16"
        viewBox="0 0 9 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.72496 7.09982C8.90083 7.27546 8.99974 7.51376 8.99996 7.76232V8.23732C8.99708 8.48533 8.89857 8.72267 8.72496 8.89982L2.29996 15.3123C2.18261 15.4306 2.02286 15.4972 1.85621 15.4972C1.68956 15.4972 1.52982 15.4306 1.41246 15.3123L0.524962 14.4248C0.407382 14.3096 0.341123 14.1519 0.341123 13.9873C0.341123 13.8227 0.407382 13.665 0.524962 13.5498L6.08746 7.99982L0.524962 2.44982C0.406641 2.33246 0.340088 2.17271 0.340088 2.00607C0.340088 1.83942 0.406641 1.67967 0.524962 1.56232L1.41246 0.687315C1.52982 0.568995 1.68956 0.502441 1.85621 0.502441C2.02286 0.502441 2.18261 0.568995 2.29996 0.687315L8.72496 7.09982Z"
          fill="#0f1560"
        />
      </svg>
    </div>
  );
};

export default AngleBracketIcon;
